
export default [
    {
      path: '/scores/',
      name: 'Scores',
      component: () => import('../../components/legacy/Scores.vue'),
    },
    {
      path: '/ptree/:id',
      name: 'pTree',
      component: () => import('../views/PTree.vue'),
    },
    {
      path: '/indexes/add/',
      name: 'AddIndex',
      component: () => import('../../components/legacy/EditIndex.vue'),
    },
    {
      path: '/indexes/:id/edit/',
      name: 'EditIndex',
      component: () => import('../components/EditIndex.vue'),
    },
    {
      path: '/indexes/',
      name: 'Indexes',
      component: () => import('../components/Indexes.vue'),
    },
    // {
    //   path: '/templates/add/',
    //   name: 'AddTemplate',
    //   component: () => import('../../components/legacy/EditTemplate.vue'),
    // },
    // {
    //   path: '/templates/:id/edit/',
    //   name: 'EditTemplate',
    //   component: () => import('../../components/legacy/EditTemplate.vue'),
    // },
    // {
    //   path: '/templates/',
    //   name: 'Templates',
    //   component: () => import('../../components/legacy/Templates.vue'),
    // },
    {
      path: '/category_definitions/add/',
      name: 'AddCategoryDefinition',
      component: () => import('../../components/legacy/EditCategoryDefinition.vue'),
    },
    {
      path: '/category_definitions/:id/edit/',
      name: 'EditCategoryDefinition',
      component: () => import('../../components/legacy/EditCategoryDefinition.vue'),
    },
    {
      path: '/category_definitions/',
      name: 'CategoryDefinitions',
      component: () => import('../../components/legacy/CategoryDefinitions.vue'),
    },
    {
      path: '/display_index/:id/',
      name: 'DisplayIndex',
      component: () => import('../components/DisplayIndex.vue'),
    },
    {
      path: '/display_tree/',
      name: 'DisplayTree',
      component: () => import('../../components/legacy/DisplayTree.vue'),
    },
    {
      path: '/view-api/:collection/:pattern/get_recs',
      name: 'ViewApiGetRecs',
      component: () => import('../components/ViewApi.vue'),
    },
    {
      path: '/view-api/:collection/:id/get_rec',
      name: 'ViewApiGetRec',
      component: () => import('../components/ViewApi.vue'),
    },
    {
      path: '/view-api/:collection/:parent_id/get_children',
      name: 'ViewApiGetChildren',
      component: () => import('../components/ViewApi.vue'),
    },
    {
      path: '/view-api/:collection/:my_id/get_siblings',
      name: 'ViewApiGetSiblings',
      component: () => import('../components/ViewApi.vue'),
    },
    {
      path: '/view-api/:collection/:my_id/get_parent',
      name: 'ViewApiGetParent',
      component: () => import('../components/ViewApi.vue'),
    },
    {
      path: '/view-api/:collection/:my_id/get_parent_children',
      name: 'ViewApiGetParentChildren',
      component: () => import('../components/ViewApi.vue'),
    },
    {
      path: '/view-api/:collection/:my_id/get_whole_rec',
      name: 'ViewApiGetWholeRecord',
      component: () => import('../components/ViewApi.vue'),

    },

  ]
